import { render, staticRenderFns } from "./CoachProfile.vue?vue&type=template&id=88e3d868&"
import script from "./CoachProfile.vue?vue&type=script&lang=ts&"
export * from "./CoachProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CoachProfile.vue?vue&type=style&index=0&id=88e3d868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports